var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flow-flex-center jFlow" }, [
    _c(
      "div",
      { staticClass: "wrap" },
      [
        _c(
          "div",
          { staticClass: "bullet-center fl-right" },
          [
            _c("router-link", { attrs: { to: "/flows" } }, [
              _c("i", { staticClass: "fa fa-times" })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("jFormFlowType2", {
          ref: "formFlowType2",
          attrs: { mode: "edit" },
          on: { getData: _vm.getData }
        }),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", [
              _c(
                "div",
                { staticClass: "float-to-left m__t--50" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn red",
                      on: {
                        click: function($event) {
                          _vm.$refs.formFlowType2.validateForm()
                        }
                      }
                    },
                    [_vm._v("\n            Delete\n          ")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("b-col", [
              _c(
                "div",
                { staticClass: "float-to-right m__t--50 m__l--24" },
                [
                  _c(
                    "b-button",
                    { staticClass: "btn blue", on: { click: _vm.sendData } },
                    [_vm._v("\n            Update\n          ")]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bullet-center" }, [
      _c("h2", [_vm._v("Update Flow By Division")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c3792b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c3792b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/edit/jFlowEditType2.vue
// module id = null
// module chunks = 